/**
 * Sonmol Video — lazy autoplay + click-to-play UX.
 *
 * Anti-phantom-play : si un événement `play` se déclenche dans la seconde
 * suivant un pause volontaire de l'utilisateur (clic sur la vidéo), on
 * le neutralise. Évite que la pause soit "annulée" par un comportement
 * natif du browser ou un autre listener.
 */
(function () {
  function init(player) {
    if (player.dataset.sonmolInit === 'true') return;
    player.dataset.sonmolInit = 'true';

    var frame = player.parentElement;
    if (!frame) return;

    var shouldAutoplay = player.dataset.autoplay === 'true';
    var lastClickAt = 0;
    var userPausedAt = 0;
    var userPlayedAt = 0;
    var hasEnteredOnce = false;

    function clickDebounced() {
      var now = Date.now();
      if (now - lastClickAt < 250) return true;
      lastClickAt = now;
      return false;
    }

    function syncPausedState() {
      if (player.paused || player.ended) {
        frame.classList.add('sonmol-video__frame--paused');
      } else {
        frame.classList.remove('sonmol-video__frame--paused');
      }
    }

    function safePlay() {
      userPlayedAt = Date.now();
      var p = player.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {
          /* autoplay blocked — overlay stays visible, user can click */
        });
      }
    }

    function userPause() {
      userPausedAt = Date.now();
      player.pause();
    }

    // Click anywhere on the video → toggle play/pause
    player.addEventListener('click', function () {
      if (clickDebounced()) return;
      if (player.paused) {
        safePlay();
      } else {
        userPause();
      }
    });

    // Click on the big overlay play button (visible only when paused) → play
    var overlay = frame.querySelector('.sonmol-video__overlay-play');
    if (overlay) {
      overlay.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (clickDebounced()) return;
        safePlay();
      });
    }

    // Anti-phantom-play : si l'utilisateur a explicitement pause récemment
    // et qu'un évènement `play` arrive sans qu'il ait cliqué pour relancer,
    // on annule.
    player.addEventListener('play', function () {
      if (userPausedAt > userPlayedAt && Date.now() - userPausedAt < 1000) {
        player.pause();
        return;
      }
      syncPausedState();
    });

    player.addEventListener('playing', syncPausedState);
    player.addEventListener('pause', syncPausedState);
    player.addEventListener('ended', syncPausedState);
    player.addEventListener('loadedmetadata', syncPausedState);

    syncPausedState();

    // Lazy autoplay (uniquement si data-autoplay="true")
    if (shouldAutoplay && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (player.paused) safePlay();
              hasEnteredOnce = true;
            } else if (hasEnteredOnce && !player.paused) {
              player.pause();
            }
          });
        },
        {
          threshold: 0.25,
          rootMargin: '0px 0px 200px 0px'
        }
      );
      observer.observe(player);
    }
  }

  function bootstrap() {
    var players = document.querySelectorAll('.sonmol-video__player');
    Array.prototype.forEach.call(players, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
